import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const Bloggers = () => (
  <Page {...seo.bloggers}>
    <h2 className="mt-0">TRAVELERS, BLOGGERS, AND VLOGGERS</h2>
    <p className="mb-1">Hello there,</p>
    <p>
      As avid mountain lovers ourselves, we understand that you wish to simply just quit
      everything and keep traveling. While we do not have a fairy to make that happen, we
      have tried to create something that will take you a little bit closer to that goal.
    </p>
    <p>
      Specifically, through HoneyGuide, you will be able to:
      <ol>
        <li>Get Ideas for hikes and treks and plan it.</li>
        <li>Actually Experience and Understand the land and people while you travel.</li>
        <li>
          Share your love of travel and knowledge with other travelers, and Get
          Opportunities to travel for Free
        </li>
        <li>Sell Unique Treks.</li>
        <li>
          Refer your fans to a Community that believes in Transparency in Travel and
          Promotes Local Service Providers.
        </li>
      </ol>
    </p>
    <p>
      Some of the key features of HoneyGuide that enables these things are:
      <ol>
        <li>Comprehensive and Authoritative information on treks and hikes.</li>
        <li>Immersive Content like Local Folklore, Birds, Flowers, and Mountains.</li>
        <li>
          There are frequent opportunities to travel through HoneyGuide or Destination
          Promotion Organizations we partner with.
        </li>
        <li>
          HoneyGuide can showcase your unique treks, manage payments and even help you with
          logistical support if needed.
        </li>
        <li>
          Join Our Affiliate Program and earn Money through easy to setup Promo Codes and
          Affiliate Widgets.
        </li>
      </ol>
    </p>
    <p>
      You might wish to check out the following to get a sense of what we mean:
      <ol>
        <li>
          Trekking in Nepal Mobile App-{' '}
          <a href="https://play.google.com/store/apps/details?id=com.trekkinginnepal.app&hl=en">
            Android
          </a>{' '}
          and{' '}
          <a href="https://itunes.apple.com/la/app/trekking-in-nepal/id1112263577?mt=8">
            iOS
          </a>
        </li>
        <li>
          <a href="https://play.google.com/store/apps/details?id=com.tds.farwestnepal">
            Far West Nepal Mobile App
          </a>{' '}
          created in partnership with GiZ and Tourism Development Society.
        </li>
        <li>
          <a href="https://honeyguideapps.com/treks/sweet-gold-honey-hunting-trek.e60bf6bb2f2f.annapurna-region">
            Sweet Gold Trek
          </a>{' '}
          by Ayush Bista.
        </li>
        <li>
          Affiliate Widget Example in{' '}
          <a
            href="https://www.mappingmegan.com/guide-to-the-mount-everest-base-camp-trek/"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            Mapping Megan’s Blog.
          </a>
        </li>
      </ol>
    </p>
    <p>
      If you are interested in creating content, let us know what you are interested in:
    </p>
    <p>
      Writing, Photography, Videography. <br />
      If you wish to sell a Unique Trek/Hike through HoneyGuide, tell us a little bit about
      it.
    </p>
    <p>
      If you wish to partner with HoneyGuide in its Affiliate Program, put links to your
      youtube channel, blog, Instagram account or other online profiles.
    </p>
    <p>We would love to talk to you, tell us a little bit about yourself.</p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha<br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSf9HsQkbSsXpXdrK3XSSDeagBQS-NX1xBqlAlFmaGZeO6vYkA/viewform?embedded=true"
      width="100%"
      height="843"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Bloggers"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default Bloggers;



// WEBPACK FOOTER //
// ./src/screens/Partners/Bloggers.jsx